import { CONTENT_LIST_PAGE_COPY } from '../lib/contentListPageConstants';
import type { ListPatternProps } from '../lib/contentListPageTypes';
import type { ListPatternState } from '../lib/listPatternState';
import { SiteGridFadeIn } from './SiteFadeIn';

interface ListPatternBodyProps {
  listProps: ListPatternProps;
  state: ListPatternState;
}

export function ListPatternBody({ listProps, state }: ListPatternBodyProps) {
  if (state.status === 'loading') {
    return null;
  }

  if (state.status === 'error') {
    return (
      <p className="text-body text-status-error">
        {state.errorMessage ?? CONTENT_LIST_PAGE_COPY.defaultError}
      </p>
    );
  }

  if (state.status === 'empty') {
    return (
      <p className="text-body text-text-tertiary">
        {listProps.emptyMessage}
      </p>
    );
  }

  if (state.status === 'success') {
    return (
      <SiteGridFadeIn>
        {listProps.renderItems(state.items)}
      </SiteGridFadeIn>
    );
  }

  return null;
}
